// src/components/Footer.js
import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="app-footer">
      <p>© 2026 ThreatPen Platform - DistriNet @ KU Leuven. All Rights Reserved.</p>
    </footer>
  );
}

export default Footer;
